import React from 'react';
import { CalButton } from './ui/CalButton';
import { Mail, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { contactCopy } from '../data/translations/contact';
export function ContactSection() {
  const {
    language
  } = useLanguage();
  const copy = contactCopy[language];
  return <section id="contact" className="surface-b blend-top relative pt-24 pb-56" data-id="element-31" data-mp="2pgdxqxgq2hv0">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-32" data-mp="3d946yyx8qn1l">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-33" data-mp="3i633tp8ah83h">
          <h2 className="font-serif text-4xl md:text-5xl text-ink-900 mb-4" data-id="element-34" data-mp="1sqwne56so7mz">
            {copy.heading}
          </h2>
          <p className="text-xl text-ink-600 mb-12" data-id="element-35" data-mp="1wryo6qgd0rr2">{copy.subtext}</p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12" data-id="element-36" data-mp="7moibimwv6ay">
            <a href="tel:+31630303225" className="flex items-center space-x-3 text-bronze-600 hover:text-ink-900 transition-colors group" data-id="element-37" data-mp="2od651958jpk">
              <div className="w-12 h-12 rounded-full bg-bronze-400/10 flex items-center justify-center group-hover:bg-bronze-400/20 transition-colors" data-id="element-38" data-mp="ckzp1khwt0oy">
                <Phone size={20} data-id="element-39" data-mp="qio0y2u00xhv" />
              </div>
              <span className="text-lg font-medium" data-id="element-40" data-mp="lkw7h4dph3bk">+31 6 30303225</span>
            </a>

            <a href="mailto:info@markvcoaching.com" className="flex items-center space-x-3 text-bronze-600 hover:text-ink-900 transition-colors group" data-id="element-41" data-mp="10b3mfa4i847i">
              <div className="w-12 h-12 rounded-full bg-bronze-400/10 flex items-center justify-center group-hover:bg-bronze-400/20 transition-colors" data-id="element-42" data-mp="19aqnfutbn801">
                <Mail size={20} data-id="element-43" data-mp="14acf0bnt5w1h" />
              </div>
              <span className="text-lg font-medium" data-id="element-44" data-mp="202c11c3ddn3">
                info@markvcoaching.com
              </span>
            </a>
          </div>

          <CalButton className="!text-xl !px-10 !py-4 shadow-lg shadow-bronze-400/20" data-id="element-45" data-mp="6vzupeatuw31">
            {copy.cta}
          </CalButton>
        </motion.div>
      </div>
    </section>;
}